import React from "react";
import { Box, CircularProgress, Typography } from "@mui/material";

/**
 * A simple, centered loading spinner for page-level loading states.
 */
const PageLoader = () => {
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        minHeight: "60vh",
      }}
    >
      <CircularProgress />
      <Typography variant="body2" color="text.secondary" sx={{ mx: "auto" }}>
        Loading, please wait...
      </Typography>
    </Box>
  );
};

export default PageLoader;
